;(function () {
    const DEFAULT_AMOUNT = 40
    const DAMPING = 0.08
    const EPSILON = 0.05
    const clamp01 = (n) => Math.min(1, Math.max(0, n))
    const lerp = (a, b, t) => a + (b - a) * t
    const reduced = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
    ).matches

    const supportsViewTimeline =
        typeof CSS !== "undefined" &&
        typeof CSS.supports === "function" &&
        CSS.supports("animation-timeline", "view()")

    function hasScrollportAbove(host) {
        for (
            let node = host.parentElement;
            node && node !== document.body && node !== document.documentElement;
            node = node.parentElement
        ) {
            const { overflowX, overflowY } = getComputedStyle(node)
            const scrolls = (value) => value !== "visible" && value !== "clip"
            if (scrolls(overflowX) || scrolls(overflowY)) return true
        }
        return false
    }

    function init() {
        const els = [...document.querySelectorAll(".js-parallax")]
        if (!els.length || reduced) return

        const fallback = []

        const timelineNames = new Map()

        els.forEach((el, index) => {
            const hostSelector = el.dataset.parallaxHost
            const host =
                (hostSelector ? el.closest(hostSelector) : el.parentElement) ||
                el
            const amount = Number(el.dataset.amount) || DEFAULT_AMOUNT

            if (
                supportsViewTimeline &&
                host !== el &&
                !hasScrollportAbove(host)
            ) {
                let name = timelineNames.get(host)
                if (!name) {
                    name = `--js-parallax-${index}`
                    timelineNames.set(host, name)
                    host.style.setProperty("view-timeline-name", name)
                    host.style.setProperty("view-timeline-axis", "block")
                }
                el.style.setProperty("--parallax-amount", `${amount}px`)
                el.style.setProperty("animation-name", "js-parallax-shift")
                el.style.setProperty("animation-duration", "auto")
                el.style.setProperty("animation-timing-function", "linear")
                el.style.setProperty("animation-fill-mode", "both")
                el.style.setProperty("animation-timeline", name)
                el.style.setProperty("animation-range", "cover 0% cover 100%")
                return
            }

            fallback.push({
                el,
                host,
                amount,
                cur: 0,
                target: 0,
                painted: null,
                visible: true,
            })
        })

        if (!fallback.length) return

        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        const item = fallback.find(
                            (candidate) => candidate.host === entry.target
                        )
                        if (!item) return

                        if (entry.isIntersecting && !item.visible)
                            item.reset = true
                        item.visible = entry.isIntersecting

                        item.el.style.willChange = entry.isIntersecting
                            ? "transform"
                            : "auto"
                    })
                },
                { rootMargin: "10% 0px" }
            )
            fallback.forEach((item) => observer.observe(item.host))
        } else {
            fallback.forEach((item) => (item.el.style.willChange = "transform"))
        }

        fallback.forEach(
            (item) => (item.el.style.backfaceVisibility = "hidden")
        )

        function measure() {
            const vh = window.innerHeight
            for (const item of fallback) {
                if (!item.visible) continue
                const rect = item.host.getBoundingClientRect()
                const progress = clamp01((vh - rect.top) / (vh + rect.height))
                item.target = (progress - 0.5) * 2 * item.amount
            }
        }

        function paint() {
            for (const item of fallback) {
                if (!item.visible) continue
                if (item.reset) {
                    item.cur = item.target
                    item.reset = false
                } else {
                    item.cur = lerp(item.cur, item.target, DAMPING)
                }
                if (
                    item.painted !== null &&
                    Math.abs(item.cur - item.painted) < EPSILON
                )
                    continue
                item.painted = item.cur
                item.el.style.transform = `translate3d(0, ${item.cur.toFixed(2)}px, 0)`
            }
        }

        if (window.themeTicker) {
            window.themeTicker.read(measure)
            window.themeTicker.write(paint)
        } else {
            const frame = () => {
                measure()
                paint()
                requestAnimationFrame(frame)
            }
            requestAnimationFrame(frame)
        }
    }

    document.addEventListener("DOMContentLoaded", init)
})()